import { createTouchControls } from '../ui/touchControls';
import type { Runtime } from './runtime';

export function createRuntimeTouch(runtime: () => Runtime, menu: () => void) {
  return createTouchControls({
    menu,
    view: () => {
      runtime().visitorView.toggleView();
    },
    chat: () => {
      runtime().communications.openChat();
    },
  });
}

export function updateRuntimeTouch(rt: Runtime, blocked: boolean): void {
  rt.touch.update({
    mode: rt.control.controlState.mode,
    multiplayer: rt.gameMode === 'multi',
    blocked: blocked || rt.options.still,
    touring: rt.tours.state() !== null,
    behind: rt.visitorView.behind,
  });
}
